<template>
	<div>
		<x-modal
			:wWidth="1080"
			v-if="isVisible"
			@cancel="emailForwardReplyModalClose"
			@close="emailForwardReplyModalClose"
			@ok="emailForwardReplyModalSubmit"
			:draggable="true"
			:resizable="true"
			:loading="loading"
			:okDisabled="emailForwardReplyModalButtonDisabled"
			:okText="action == 'forward' ? 'Forward Email' : 'Send Reply'"
		>
			<div slot="title" :class="`d-flex justify-content-between align-items-center`">
				{{ action == "forward" ? "Forward Email" : "Send Reply" }}
			</div>

			<div class="container">
				<el-form label-width="140px">

                    <email-sending-options
                        :show-send-sms="false">
                    </email-sending-options>

					<email-recipients
						v-if="sendEmail"
						:autoSelectRecipients="false"
						:addRecipients="action == 'reply' ? [email.from] : []"
					></email-recipients>

					<email-task v-model="emailBuilder.task"></email-task>

					<el-divider v-if="!_.isEmpty(emailBuilder.recipients) && sendEmail"></el-divider>

					<email-markup-multi
						class="mb-3"
						v-if="!_.isEmpty(emailBuilder.recipients) && sendEmail"
						action="reply-forward-email"
                        :appendAttachments="emailAttachments"
						:data="{
							original: emailBody,
						}"
					></email-markup-multi>
				</el-form>
			</div>
		</x-modal>
	</div>
</template>

<script>
    import EmailSendingOptions from "@ambition/components/messages/EmailSendingOptions.vue"
	import EmailRecipients from "@ambition/components/messages/EmailRecipients"
	import EmailAttachments from "@ambition/components/messages/EmailAttachments"
	import EmailMarkupMulti from "@ambition/components/messages/EmailMarkupMulti"
	import EmailTask from "@ambition/components/messages/EmailTask"
	import { mapGetters } from "vuex"

	export default {
		name: "EmailForwardReplyModal",
		props: {
			visible: {
				required: true,
				type: Boolean,
			},
			action: {
				required: true,
				type: String,
			},
			email: {
				required: true,
				type: Object,
			},
		},
		components: {
            EmailSendingOptions,
			EmailRecipients,
			EmailAttachments,
			EmailMarkupMulti,
			EmailTask,
		},
		watch: {
			visible(visible) {
				this.isVisible = visible
			},
		},
		data() {
			return {
				sendEmail: true,
				isVisible: false,
				loading: false,
			}
		},
		mounted() {},
		activated() {},
		computed: {
			...mapGetters({
				docDocuments: "documents/all",
				emailBuilder: "builderEmail/getEmail",
                templatesLoaded: "builderEmail/checkTemplatesLoaded",
			}),
			emailForwardReplyModalButtonDisabled() {
                if (!this.templatesLoaded) return true
                if (this.emailBuilder.delaySending && !this.emailBuilder.sendAt) return true
				if (_.size(this.emailBuilder.recipients) >= 1 && !this.loading) return false
				return true
			},
			formattedAction() {
				if (!this.action) return
				return _.startCase(_.toLower(this.action))
			},
			emailBody() {

                let body = false
                if (this.email.body) {
                    body = this.email.body
                } else {
                    body = this.email.message_body
                }

                let emailMarkup = ''
                if (body) {
                    let parser = new DOMParser()
                    let doc = parser.parseFromString(body, "text/html")
                    emailMarkup = doc.getElementsByTagName("body")[0].innerHTML
                }

				let emailBody = ""
				if (this.action == "forward") {
					let from =
						typeof this.email.from_name !== "undefined" ? this.email.from_name + " <" + this.email.from + ">" : this.email.from
					let emailSent = this.$moment(new Date(this.email.created_at)).format("LLLL")
					emailBody =
						"<section class='container tenant-background-white' style='padding: 0 20px;background:#ffffff;max-width: 600px; margin: auto;font-size: 14px!important'><br/><br/><p style='border-top: 1px solid #555555; padding-top: 15px;'>---------- Original Message ---------<br/>" +
						"From: " +
						from +
						" <br/>" +
						"Sent: " +
						emailSent +
						"<br/>" +
						"To: " +
						this.email.to +
						"<br/>"
					if (this.email.cc != null && this.email.cc != "[]") {
						emailBody += "Cc: " + this.email.cc + "<br/>"
					}
					emailBody += "Subject: " + this.email.subject + "</p><br/><br/>" + emailMarkup + "</section>"
					return emailBody
				}
				return emailMarkup
			},

			emailAttachments() {

                let attachments = []
                if (_.isString(this.email.attachments)) {
                    attachments = JSON.parse(this.email.attachments)
                } else if (_.isArray(this.email.attachments)) {
                    attachments = this.email.attachments
                }

                if (!_.isEmpty(attachments)) {
                    let docAttachments = []

                    attachments.forEach((attachment) => {
                        let appDocument = this.docDocuments.find((document) => document.id == attachment.id && document.filename == attachment.file_name)
                        if (appDocument) {
                            if (_.isNull(appDocument.document_type)) Vue.set(appDocument, 'document_type', {})
                            Vue.set(appDocument.document_type, 'document_type', 'CURRENT EMAIL')
                            docAttachments.push(appDocument)
                        } else {
                            let emailAttachmentDocument = Object.assign({}, {
                                id: `${attachment.id}-2`,
                                uploaded: true,
                                document_type: {
                                    document_type: "CURRENT EMAIL",
                                },
                                name: attachment.name,
                                filename: attachment.name,
                                email_attachment: true,
                                is_app_document: false,
                                url: attachment.temporary_url ? attachment.temporary_url : attachment.url,
                                file_size: 1
                            })
                            docAttachments.push(emailAttachmentDocument)
                        }
                    })

                    return this.action == 'forward' ? docAttachments : []

                }
				return []
			},
		},
		methods: {
			emailForwardReplyModalClose() {
				this.$store.dispatch("builderEmail/setRecipients", [])
				this.$store.dispatch("builderEmail/setCc", [])
				this.$store.dispatch("builderEmail/setBcc", [])
				this.loading = false
				this.isVisible = false
				this.$emit("update:visible", false)
			},
			async emailForwardReplyModalSubmit() {
				this.loading = true

				let headers = {
					headers: { Authorization: "Bearer " + this.$store.getters.token },
				}

				await axios
					.post(`/api/builder-email`, { email: this.emailBuilder }, headers)
					.then((response) => {
						// create application task
                        if (_.get(this.emailBuilder, 'task.create', false)) {
                            this.$store.dispatch("statusIndicators/changeStatus", {
                                stage: "createTask",
                                token: this.$store.getters.token,
                                remindMe: this.$moment(this.emailBuilder.task.remindMe).format("YYYY-MM-DD"),
                                taskName: this.emailBuilder.task.name,
                                time: this.emailBuilder.task.time,
                                userId: this.emailBuilder.task.userId,
                                appId: this.$store.getters.initAppData.id
                            })
                        }

                            // create recipient tasks
                        if (_.get(this.emailBuilder, 'recipients', false)) {
                            this.emailBuilder.recipients.forEach(recipient => {
                                if (_.get(recipient, 'template.task.create', false)) {
                                    this.$store.dispatch("statusIndicators/changeStatus", {
                                        stage: "createTask",
                                        token: this.$store.getters.token,
                                        remindMe: this.$moment(recipient.template.task.remindMe).format("YYYY-MM-DD"),
                                        taskName: recipient.template.task.name,
                                        time: recipient.template.task.time,
                                        userId: recipient.template.task.userId,
                                        appId: this.$store.getters.initAppData.id
                                    })
                                }
                            })
                        }
						this.emailForwardReplyModalClose()
						swal({
							type: "success",
							text: "The email has been sent",
							title: "Success!",
						})
					})
					.catch((error) => {
						this.emailForwardReplyModalClose()
						swal({
							type: "error",
							text: "There was an error sending this email",
							title: "Error!",
						})
					})
			},
		},
	}
</script>
